import { toast } from "react-toastify";

export default function useHandleErrors() {
    const handleErrors = (response: any) => {
        if (!response.success) {
            if (response.data?.errors) {
                response.data.errors.forEach((error: any) => {
                    //toast.error(error.property + ": " + error.message);
                    toast.error(error.message);
                });
            } else {
                toast.error(response.message);
            }
        }
    }

    return { handleErrors };
}

/**
 * ES: Manejar errores en las respuestas de la API cuando son de tipo ArrayBuffer
 * EN: Handle errors in API responses when they are of type ArrayBuffer
 */
export function useHandleErrorsDecoder() {
    const handleErrorsDecoder = (response: any) => {
        if (!response.success) {
            if (response.data?.errors) {
                response.data.errors.forEach((error: any) => {
                    toast.error(error.message);
                });
            } else {
                const decodedText = new TextDecoder('utf-8').decode(new Uint8Array(response?.response?.data));
                const jsonError = JSON.parse(decodedText);
                toast.error(jsonError.message);
            }
        }
    }

    return { handleErrorsDecoder };
}